module.exports = __webpack_public_path__ + "images/2b69c277e72815efa230f735f16bb964.png";